import styled from "styled-components";

export const ModalHeader = styled.div`
  background: #ffffff;
  padding: 30px 30px 0;
  text-align: left;
  position: relative;
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 30px;
  width: 60px;
  height: 60px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const MainHeading = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: #000000;
  margin: 0;
  line-height: 1.3;
  max-width: 75%;
`;

export const ModalBody = styled.div`
  padding: 20px 30px 0;
`;

export const SectionLabel = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: #4a4a4a;
`;

export const SectionContent = styled.div`
  font-size: 16px;
  line-height: 1.5;
  color: #000000;
`;

export const Description = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #4a4a4a;
  line-height: 1.6;
  margin: 0 0 20px 0;
`;

export const PersuasionBox = styled.div`
  background: #e8f4f8;
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  line-height: 1.5;
  color: #006064;
  font-weight: 400;

  span {
    display: inline;
  }
`;

export const ListContainer = styled.div`
  padding: 16px 30px 30px;
`;

export const BulletList = styled.ul`
  list-style: none;
  margin: 0 0 30px 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BulletItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const BulletIcon = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #000000;
  flex-shrink: 0;
  margin-top: 8px;
`;

export const BulletText = styled.div`
  font-size: 16px;
  line-height: 1.5;
  color: #000000;
  flex: 1;
`;
